import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useFunnelStepsList(id) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== id || $[2] !== user) {
    t1 = () => {
      if (user && id) {
        return `${FUNNELS_API}/${id}/steps/list`;
      }
      return null;
    };
    $[1] = id;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: funnelStepsList,
    mutate: mutateFunnelStepsList
  } = useSWR(t1, fetcher);
  let t2;
  if ($[4] !== funnelStepsList || $[5] !== mutateFunnelStepsList) {
    t2 = {
      funnelStepsList,
      mutateFunnelStepsList
    };
    $[4] = funnelStepsList;
    $[5] = mutateFunnelStepsList;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}